export enum RequestTransactionType {
	Complaint = "complaint",
	Report = "report",
	ProfessionalCompliance = "professional_compliance",
}
